import * as Preact from "preact"
import Pointer from "poin"

import App from "@fae/source/models/App.js"
import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"
// import Random from "@fae/source/utility/Random.js"
// const random = new Random()

import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import DiceLayout from "@fae/source/data/games/ember/views/DiceLayout.jsx"
import UnitManagementSection from "@fae/source/data/games/ember/views/UnitManagementSection.jsx"

import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import "./LootModal.less"

import CHESTS from "@fae/source/data/games/ember/chests.js"
let RANDOMIZED_CHESTS = Object.values(CHESTS)

import items from "@fae/source/data/games/ember/items.jsx"
// DUPED FROM MERCHANT MODAL
function getDraftableItems(stage, amount = 6) {
    // if(stage.overworld.player.encounter.items != undefined) {
    //     return stage.overworld.player.encounter.items
    // }

    // const units = Object.values(stage.units).filter((unit) => {
    //     return unit.isDead != true
    //         && unit.isRecruited == true
    //         && unit.affiliation == stage.player.affiliation
    //         && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
    // })

    let draftableItems = []
    draftableItems = Object.values(items).filter((item) => item.isDraftable == true)

    if((stage?.overworld?.player?.position?.x || 0) <= 3) { // TODO: UNHARDCODE THIS!!!
        draftableItems = Object.values(items).filter((item) => item.draftTier == 1)
    }

    draftableItems = draftableItems.map((item) => ({...item}))
    draftableItems = stage.random.shuffle(draftableItems)

    let draftLength = 3 + Math.floor(stage.overworld.player.position / 4)
    draftableItems = draftableItems.slice(0, amount)

    return draftableItems
}

export default function LootModal() {
    return [
        {
            "func": function(stage) {
                if(stage.overworld.player.encounter.items != undefined) {
                    const chests = stage.overworld.player.encounter.items.map((item) => {
                        return {
                            "equipment": {
                                "items": {
                                    "0": item,
                                }
                            }
                        }
                    })
                    window.generatedChests = chests
                } else {
                    const chests = getDraftableItems(stage, 3).map((item) => {
                        return {
                            "equipment": {
                                "items": {
                                    "0": item,
                                }
                            }
                        }
                    })
                    // const chests = []
                    //
                    // const units = Object.values(stage.units).filter((unit) => {
                    //     return unit.isDead != true
                    //         && unit.isRecruited == true
                    //         && unit.affiliation == stage.player.affiliation
                    //         && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
                    // })
                    //
                    // if(RANDOMIZED_CHESTS == undefined) return
                    // RANDOMIZED_CHESTS = stage.random.shuffle(RANDOMIZED_CHESTS)
                    // // TODO: filter this list based on variables like:
                    // // - who is alive, and what they can weild
                    // // - who already has a lot of loot
                    // // - what has been seen already?? using something other than popping.
                    //
                    // const CHEST_COUNT = 3
                    // for(let i = 0; i < CHEST_COUNT; i += 1) {
                    //     chests.push(RANDOMIZED_CHESTS.pop())
                    //
                    //     // if we ate all the content, refill and reshuffle
                    //     if(RANDOMIZED_CHESTS.length == 0) {
                    //         RANDOMIZED_CHESTS = stage.random.shuffle(CHESTS)
                    //     }
                    // }

                    window.generatedChests = chests // TODO AAAAAH IT IS 3:33AM BEFORE THE 7DRL DEADLINE PLEASE FORGIVE ME
                    // TODO: put this in stage.overworld.player.encounter.chests
                }
            }
        },
        PlotSteps.CustomViewModal({
            "view": (stage) => {
                if(App?.game == undefined) return

                // return <InventoryModal stage={stage}/> // DEBUG

                if(window.navigatedModalScreen == "EquipmentScreen") {
                    return <InventoryModal stage={stage}/>
                } else {
                    return <DraftModal stage={stage}/>
                }
            }
        }),
    ]
}

class DraftModal {
    render() {
        const stage = this.props.stage
        const chests = stage.overworld.player.encounter.chests || window.generatedChests // TODO AAAAAH IT IS 3:33AM BEFORE THE 7DRL DEADLINE PLEASE FORGIVE ME
        // <div class="Name"><span>{chest.equipment.name ?? chest.equipment.items[0]?.title}</span></div>
        return (
            <div class="LootModal">
                <div class="Header">
                    <div class="BigText">Choose a weapon</div>
                    <div class="SmallText">(Right-click to learn more)</div>
                </div>
                <section class="UnitsSection">
                    {Object.values(chests).map((chest, index) => {
                        return (
                            <div class="Unit">
                                <div class="DraftableDice" onClick={this.onClickDraft({stage, chest})}>
                                    <Dice item={chest.equipment.items[0]} anchored={"bottom"}/>
                                    {false && <DiceLayout items={chest.equipment.items} unit={stage.units.ashe} stage={stage} anchored={"bottom"}/>}
                                </div>
                            </div>
                        )
                    })}
                </section>
                <div class="SkipButton" onClick={this.onClickSkip(stage)} isEnabled={true}>
                    <div class="Text">Skip</div>
                </div>
            </div>
        )
    }
    onClickDraft({stage, chest}) {
        return function(event) {
            if(chest?.equipment == undefined) return

            const equipment = {
                "key": stage.random.key(),
                ...chest.equipment,
            }

            stage.player.equipments[equipment.key] = equipment
            window.selectedChest = chest
            window.navigatedModalScreen = "EquipmentScreen"
        }
    }
    onClickSkip(stage) {
        return function(event) {
            CarryOn(stage)
        }
    }
}

class InventoryModal {
    render() {
        const stage = this.props.stage
        return (
            <div class="EquipmentScreen">
                <div class="SelectedItemCursor" hasSelected={window.selectedItem != undefined} style={{"top": Pointer.position.y, "left": Pointer.position.x}}>
                    <Dice item={window.selectedItem} anchored={"bottom"}/>
                </div>
                <UnitManagementSection stage={stage} direction="horizontal"/>
                <div class="ItemsSection">
                    <div class="SelectedItem">
                        <Dice item={(window.selectedChest?.equipment?.items || {})[0]} anchored={"bottom"}
                            onMouseDown={this.onClickDraftedItem()}/>
                    </div>
                    <div class="Button">
                        <div class="SkipButton" onClick={this.onClickContinue(stage)} isVisible={window.selectedChest != undefined && window.selectedItem == undefined}>
                            Skip
                        </div>
                        <div class="ContinueButton" onClick={this.onClickContinue(stage)} isVisible={window.selectedChest == undefined && window.selectedItem == undefined}>
                            Continue
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    onClickDraftedItem() {
        return function(event) {
            const MOUSE_BUTTON = 0
            if(event.button != MOUSE_BUTTON) return

            if(window.selectedItem == undefined
            && window.selectedChest != undefined) {
                // if(unit.equippableWeapons?.includes(chestItem.weaponType) == false) return
                window.selectedItem = window.selectedChest.equipment.items[0]
                window.selectedItemSlotKey = "draft"
                window.selectedChest = undefined
            }
        }
    }
    onClickContinue(stage) {
        return function(event) {
            if(window.selectedItem != undefined) return
            window.navigatedModalScreen = undefined
            CarryOn(stage)
        }
    }
}
